/**
 * Code.jsx
 * Engineering writing.
 */

import { PostsSummary } from '#components/PostsSummary';

export function Code(){
	return (<section>
		<div className="section-head">
			<span className="eyebrow">Engineering</span>
			<h2>Writing on code &amp; craft</h2>
		</div>
		<PostsSummary noResultsText='No engineering posts yet.' tags={['code']} />
	</section>);
}
